export default __webpack_public_path__ + "static/4-0c75f18e2d1019d5bef8bac7b9fa21ac.jpeg";